var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "invoice-schema-item",
      class: "" + (_vm.active ? "form-item-active" : "form-item-inactive"),
      style: [
        {
          color: _vm.styles.fontColor + " !important",
          fontFamily: _vm.styles.font + " !important"
        },
        _vm.containerBrandStyle
      ]
    },
    [
      _c(_vm.item.type, {
        key: _vm.item.type,
        ref: "component",
        tag: "component",
        class:
          _vm.item.type !== "Container" && _vm.item.pb == null ? "pb-3" : "",
        attrs: {
          item: _vm.brandedItem,
          styles: _vm.styles,
          font: _vm.font,
          active: _vm.active,
          "edit-mode": _vm.editMode,
          "account-logo": _vm.accountLogo,
          index: _vm.index,
          tokens: _vm.tokens,
          invoice: _vm.invoice,
          "token-map": _vm.tokenMap,
          "in-builder": _vm.inBuilder,
          "deposit-account": _vm.depositAccount,
          "has-expenses": _vm.hasExpenses,
          recurring: _vm.recurring,
          "payment-plan": _vm.paymentPlan,
          "invoice-service": _vm.invoiceService,
          "attachment-service": _vm.attachmentService,
          "scheduled-payments": _vm.scheduledPayments
        },
        on: {
          click: function($event) {
            return _vm.$emit("click", $event)
          },
          delete: function($event) {
            return _vm.$emit("delete")
          },
          change: function($event) {
            return _vm.$emit("change", $event)
          },
          "container-item-click": function($event) {
            return _vm.$emit("container-item-click", $event)
          },
          "container-item-update": function($event) {
            return _vm.$emit("container-item-update", $event)
          },
          "add-container-element": function($event) {
            return _vm.$emit("add-container-element", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }